import { memo } from 'react'

import { Keyboard } from '@/icons'

import renderText from '../../../intl'
import { LocationEditorText } from '../../../typings'

import { Props } from '../typings'
import EmptyStateContainer from './elements/EmptyStateContainer'
import EmptyStateIcon from './elements/EmptyStateIcon'
import EmptyStateTitle from './elements/EmptyStateTitle'
import EmptyStateText from './elements/EmptyStateText'

const MinQueryLengthState = (props: Props) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon>
        <Keyboard />
      </EmptyStateIcon>

      <EmptyStateTitle>{renderText(LocationEditorText.addSearchTitle)}</EmptyStateTitle>

      <EmptyStateText>{renderText(LocationEditorText.addSearchText, props)}</EmptyStateText>
    </EmptyStateContainer>
  )
}

export default memo(MinQueryLengthState)
